module.exports = "/images/icon_grants.png?cc9c3f12b02f803fabfca87aa6c771e8";